import _ from 'lodash'

const buttonStatusRestrictions = (state) => {
  const { userDetails, session } = state
  const user = userDetails
  // default is to show
  if(state.meetingEnded && !session.evaluation_completed) {
    return true
  } else if (session.session_type_key == 'session_type_one_to_one_meeting') {
    return user.p2p_opt_in && this.state.userDetails.status === 'registration_status_approved' ? false : true
  } else if (state.session.virtual_platform_name === null) {
    return true
  } else if (session.session_type_optional_value === 'TRUE') {
    switch (user.status) {
    case 'registration_status_approved':
      return false
    case 'registration_status_approved_internal':
      return session.session_type_key === 'session_type_executive_boardroom' ? false : true
    case 'registration_status_approved_sponsor':
      return session.sponsor_id != null && session.sponsor_id == user.sponsor_id ? false : true
    case 'registration_status_approved_speaker':
      return _.map(session.event_session_speakers, (speaker) => speaker.crm_contact_id).includes(user.crm_contact_id) ? false : true
    }
  }
}

export default buttonStatusRestrictions